import { queryClient } from './queryClient'
import { api } from '@/app'
import { Achievement } from '@/types'
import { analytics } from '@/services/analytics/segment'
import { createQueryManager, createQueryOperations, PaginationResponse } from '@codeleap/query'

const BASE_URL = 'achievements/'

const getBadgesProperty = (items: Achievement[]) => {
  const badges = items
    ?.filter(item => item?.levels?.current_level_index > 0)
    .map(({ name, levels }) => `${name} ${levels?.list[levels?.current_level_index].name}`)
    .join(', ')

  return badges
}

export const achievementsManager = createQueryManager<Achievement>({
  name: 'achievements',
  queryClient: queryClient.client,
  listLimit: 50,

  async listFn(limit, offset, filters) {
    const response = await api.get<PaginationResponse<Achievement>>(BASE_URL, {
      params: {
        limit,
        offset
      }
    })

    const property = getBadgesProperty(response.data.results)
    if (!!property) analytics.updateTraits({ badges: property })

    return response.data?.results
  },
  async retrieveFn(id) {
    const response = await api.get<Achievement>(`${BASE_URL}${id}/`)

    return response.data
  }
})

export const achievementsOperations = createQueryOperations({
  queryClient: queryClient.client
}).mutation('getProgress', async metric => {
  const response = await api.get(`${BASE_URL}get_progress/`, {
    params: {
      progression_metric: metric
    }
  })

  return response.data
})

export const prefetchAchievements = () => {
  queryClient.client.prefetchInfiniteQuery({
    queryKey: achievementsManager.queryKeys.keys.list,
    queryFn: () => achievementsManager.functions.list(40, 0, {}),
    initialPageParam: 0
  })
}

export const useAchievements = () => {
  const achievements = achievementsManager.useList()

  return {
    loading: achievements?.query?.isLoading || achievements?.query?.isFetching,
    items: achievements?.items ?? []
  }
}
